/** The forecast list's events (TMMAPP-0108): register rows grouped by the served `eventKey`. */
import type { RegisterRow } from '@/api/projections';

export interface ForecastGroup {
  key: string;
  date: string;
  name: string;
  plan: boolean;
  edited: boolean;
  parts: RegisterRow[];
  runningMinor: number | null;
  seriesId: number | null;
  originalOn: string | null;
  envelopeId: number | null;
  /** A plan line's event (TMMAPP-0112): an envelope's plan, or an expected item on the virtual account. */
  planLineId: number | null;
  /** An unresolved past one-off drawn at today (TMMAPI-0148); `originalOn` is its own date. */
  overdue: boolean;
}

/** The register's event rows, consecutive rows with one `eventKey` grouped into one event. */
export function forecastGroups(register: readonly RegisterRow[]): ForecastGroup[] {
  const groups: ForecastGroup[] = [];
  register
    .filter((row) => row.kind === 'SLICE' || row.kind === 'PLANNED_EXPENSE')
    .forEach((row, index) => {
      const key = row.eventKey ?? `row-${index}`;
      const last = groups[groups.length - 1];
      const plan = row.kind === 'PLANNED_EXPENSE' || row.sourceKind === 'BUDGET_PLAN';
      if (last !== undefined && row.eventKey !== null && last.key === key) {
        last.parts.push(row);
        last.runningMinor = row.runningBalanceMinor;
        last.edited = last.edited || row.edited === true;
        last.overdue = last.overdue || row.overdue;
        return;
      }
      groups.push({
        key,
        date: row.occursOn ?? row.date,
        name: row.payee ?? row.note ?? row.envelopeName ?? '',
        plan,
        edited: row.edited === true,
        parts: [row],
        runningMinor: row.runningBalanceMinor,
        seriesId: row.seriesId,
        originalOn: row.originalOn,
        envelopeId: row.envelopeId,
        planLineId: row.kind === 'PLANNED_EXPENSE' ? row.planLineId : null,
        overdue: row.overdue,
      });
    });
  return groups;
}
